export default "__VITE_ASSET__SZQvYKDh__";